import { useIsProfilePreviewPage } from './is-profile-preview-page-context';

export const useTrackingParamWithContext = (trackingParam: string): string => {
  const isProfilePreviewPage = useIsProfilePreviewPage();
  const prefix = isProfilePreviewPage ? 'profile_self_preview_' : 'profile_lo_';

  return `${prefix}${trackingParam}`;
};
